import { getBankIcon } from '@sanlam-glacier/app-common/modules/theme';

export default function bankLogo(bank: string) {
  switch (bank) {
    case 'Absa':
    case 'Absa Bank':
      return getBankIcon('Absa');
    case 'African Bank':
      return getBankIcon('AfricanBank');
    case 'Bidvest Bank':
      return getBankIcon('Bidvest');
    case 'Capitec':
    case 'Capitec Bank':
      return getBankIcon('Capitec');
    case 'Discovery':
    case 'Discovery Bank':
      return getBankIcon('DiscoveryBank');
    case 'FNB':
    case 'First National Bank':
      return getBankIcon('FNB');
    case 'Grindrod':
    case 'Grindrod Bank':
      return getBankIcon('Grindrod');
    case 'Investec':
    case 'Investec Bank':
      return getBankIcon('Investec');
    case 'Nedbank':
      return getBankIcon('Nedbank');
    case 'Standard Bank':
      return getBankIcon('StandardBank');
    default:
      return getBankIcon(undefined);
  }
}
